import { Plate } from './../models/plate';
import { Step } from './../models/step';
import { Comment } from './../models/comment';
import { CommentBatch } from './../models/commentBatch';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from "../messages/messages.service";
import { ErrorHandler } from "../utils/error-handler";
import { AdminSearchService } from '../admin-search/admin-search/admin-search.service';
import { BeadChip } from './../models/bead-chip';
import { Sample } from './../models/sample';
import { Router } from '@angular/router';
import { ArrayPlateStatus, beadChipStatusDict, ngsPlateStatus, ProcessStep, BeadChipProcessStep, PlateStatus, BeadChipStatus } from '../models/process-step'
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch';
import { CommentDTO } from '../ma-comments-popup/comment-dto';
import { SampleHistoryProcessSteps } from "../models/sampleHistoryProcessSteps"
import { Action } from '../models/action';
import { BeadChipAction } from '../models/action';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import * as XLSX from 'xlsx';
import * as fileSaver from 'file-saver';
import { SampleCommentDTO } from '../models/sampleCommentDTO';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { Dropdown } from 'primeng/dropdown';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { RedoType } from '../models/redo-type-enum';
import { MultiMergePlateQCUpdate, MultiPlateUpdate, PlateUpdateInfo } from '../ma-plate-preparation/multiplate-update-dto';
import { MasterDataService } from '../masterdata/masterdata.service';
import { SampleRedoDTO, SampleWithAnalysisType } from '../models/sampleRedoDTO';
import { AnalysisType } from '../models/analysis-type';
import { AuthUtil } from '../common-services/auth-util';
import { environment } from "../../environments/environment";
import { PlateIdTypes } from '../models/plateid-types-enum';
import rfdc from 'rfdc';
import { PlateUpdateDTO } from '../ma-result-evaluation/model/ma-result-evaluation-dtos';
import { MaResultEvaluationService } from '../ma-result-evaluation/ma-result-evaluation.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const ALLOWED_ROLE_CLAIMS_FOR_HISTORY_CHANGES : string[] = [
  environment.AZURE_SUPER_USER_DK_GROUP_CLAIM, environment.AZURE_SUPER_USER_GROUP_CLAIM,
  environment.AZURE_SUPER_USER_DK_DTC_POPGEN_GROUP_CLAIM, environment.AZURE_SUPER_USER_DE_FOOD_ENVIRONMENT_GROUP_CLAIM,
  environment.AZURE_SUPER_USER_US_EBDI_GROUP_CLAIM, environment.AZURE_MDM_GROUP_ID,
  environment.AZURE_MDM_DK_GROUP_ID, environment.AZURE_MDM_DK_DTC_POPGEN_GROUP_ID,
  environment.AZURE_MDM_DE_FOOD_ENVIRONMENT_GROUP_ID, environment.AZURE_MDM_US_EBDI_GROUP_ID
]

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  showSamplePopup: boolean;
  showBeadchipPopup: boolean;
  showPlatePopup: boolean;
  selectedPlateStepsMap: Map<any, any>;
  @Input() selectedProcessFlows: ProcessFlow[];

  selectedLab: LabMDM;
  selectedLabId: string;
  plateIDRegex: string;
  beadchipIDRegex: string;
  batchIDRegex: string;
  searchedBatch: Plate;
  errorHandler: ErrorHandler = new ErrorHandler();
  blocked = false;
  selectedPlate: Plate;
  processCurrent: Step;
  selectedBeadChips: BeadChip[];
  selectedSamples: Sample[];
  plateId: any;
  wgaPlateID: any;
  pgxPlateID: any;
  beadchipID1: string;
  beadchipID2: string;
  sampleId: string;
  position: String;
  sampleBeadchip: string = ''
  sampleBeadchipPos: string = ''
  updatedStatus: string
  searchedBeadchipID: string = ''
  beadchipStatus: string = ''
  plateStatus: any[]
  searchedText: string
  statusUpdate = false
  comment: Comment
  tempStatus: string = ''
  updatedStatusComment: string
  selectedPlateID: string
  selectedPlateStatus: string
  plateCommentsList: Comment[] = []
  showCommentDialog: boolean = false
  beadChipCommentsMap: Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap: Map<string, boolean> = new Map<string, boolean>();
  fetchedCommentsPlate: Plate;
  selectedBeadChipID: string;
  commentStatusSet: boolean = false;
  statusUpdated: boolean = false;
  fieldBatchID: string = "BatchId";
  selectedBatch: Covid19Batch;
  selectedBatchStatus: string;
  selectedBatchSender: string;
  selectedBatchBatchID: string;
  newComment: string = "";
  puid: string;
  selectedBatchComments: CommentBatch[]
  batchComment: CommentBatch
  batchCommentsList: CommentBatch[]
  applicationProcess: string
  mapOfPlateProcessStepsFlow: Map<string, string[]> = new Map();
  mapOfPlateProcessStepAndAction: Map<string, string[]> = new Map();
  mapOfBeadchipProcessStepsFlow: Map<string, string[]> = new Map();
  mapOfBeadchipProcessStepAndAction: Map<string, string[]> = new Map();
  mapOfBatchesProcessStepsFlow: Map<string, string[]> = new Map();
  mapOfBatchIDAndStatus: Map<string, string[]> = new Map();
  batchSelected: Boolean = false
  sampleSelected: Boolean = false
  uploadedExternalRedoFile: File;
  isFileSelected: boolean = false;
  canBeRenderedForGivenClaim: boolean = false;

  @ViewChild("externalRedoFile")
  externalRedoFileRef:ElementRef;

  arrayPlateProcessStatusMaps = [
    { 'RECEIVE_PLATE': [PlateStatus.RECEIVED, PlateStatus.STORED] },
    { 'AMPLIFY_WGA': [PlateStatus.START_PREPCR, PlateStatus.WGA_COMPLETED, PlateStatus.PREPCR_COMPLETED] },
    { 'AMPLIFY_PGX': [PlateStatus.START_PREPCR, PlateStatus.PGX_COMPLETED, PlateStatus.PREPCR_COMPLETED] },
    { 'RECOMBINE_DNA': [PlateStatus.RECOMBINING_STARTED, PlateStatus.RECOMBINING_COMPLETED] },
    { 'FRAGMENT_DNA': [PlateStatus.FRAGMENTATION_STARTED, PlateStatus.FRAGMENTATION_COMPLETED] },
    { 'PRECIPITATE_DNA': [PlateStatus.PRECIPITATION_STARTED, PlateStatus.PRECIPITATION_COMPLETED] },
    { 'RESUSPEND_DNA': [PlateStatus.RESUSPENDING_STARTED, PlateStatus.RESUSPENDING_COMPLETED] },
    { 'DENATURATE_DNA': [PlateStatus.DENATURATION_STARTED, PlateStatus.DENATURATION_COMPLETED, PlateStatus.COMPLETLY_TRANSFERED] },
  ]
  statusPlateProcessStepMapStart = [PlateStatus.RECEIVED, PlateStatus.STORED, PlateStatus.START_PREPCR, PlateStatus.RECOMBINING_STARTED, PlateStatus.FRAGMENTATION_STARTED, PlateStatus.PRECIPITATION_STARTED, PlateStatus.RESUSPENDING_STARTED, PlateStatus.DENATURATION_STARTED]
  statusPlateProcessStepMapComplete = [PlateStatus.WGA_COMPLETED, PlateStatus.PGX_COMPLETED, PlateStatus.PREPCR_COMPLETED, PlateStatus.RECOMBINING_COMPLETED, PlateStatus.FRAGMENTATION_COMPLETED, PlateStatus.PRECIPITATION_COMPLETED, PlateStatus.RESUSPENDING_COMPLETED, PlateStatus.DENATURATION_COMPLETED]
  plateProcessArray = [ProcessStep.RECEIVE_PLATE, ProcessStep.AMPLIFY_WGA, ProcessStep.AMPLIFY_PGX, ProcessStep.RECOMBINE_DNA, ProcessStep.FRAGMENT_DNA, ProcessStep.PRECIPITATE_DNA, ProcessStep.RESUSPEND_DNA, ProcessStep.DENATURATE_DNA]

  arrayBeadchipProcessStatusMaps = [
    { "LOADING": [BeadChipStatus.LOADED] },
    { "HYBRIDIZATION": [BeadChipStatus.HYBRIDIZATION_STARTED, BeadChipStatus.HYBRIDIZATION_COMPLETED] },
    { "WASHING": [BeadChipStatus.WASHING_STARTED, BeadChipStatus.WASHING_COMPLETED] },
    { "EXTENSION": [BeadChipStatus.EXTENSION_STARTED, BeadChipStatus.EXTENSION_COMPLETED] },
    { "COATING": [BeadChipStatus.COATING_STARTED, BeadChipStatus.COATING_COMPLETED] },
    { "COMPLETED": [BeadChipStatus.BEADCHIP_IMAGED, BeadChipStatus.COMPLETED] },
  ]
  statusBeadProcessStepMapStart = [BeadChipStatus.LOADED, BeadChipStatus.HYBRIDIZATION_STARTED, BeadChipStatus.WASHING_STARTED, BeadChipStatus.EXTENSION_STARTED, BeadChipStatus.COATING_STARTED]
  statusBeadProcessStepMapComplete = [BeadChipStatus.HYBRIDIZATION_COMPLETED, BeadChipStatus.WASHING_COMPLETED, BeadChipStatus.EXTENSION_COMPLETED, BeadChipStatus.COATING_COMPLETED, BeadChipStatus.BEADCHIP_IMAGED, BeadChipStatus.COMPLETED]
  beadchipProcessArray = [BeadChipProcessStep.LOADING, BeadChipProcessStep.HYBRIDIZATION, BeadChipProcessStep.WASHING, BeadChipProcessStep.EXTENSION, BeadChipProcessStep.COATING, BeadChipProcessStep.COMPLETED]

  ngsBatchProcessStatusMaps = [
    { "RECEIVE_BATCH": [PlateStatus.BATCH_RECEIVED] },
    { "TRANSFER_PLATE": [PlateStatus.PLATE_TRANSFERRED] },
    { "SAMPLE_QC": [PlateStatus.START_SAMPLE_QC, PlateStatus.COMPLETE_SAMPLE_QC] },
    { "NORMALIZATION": [PlateStatus.START_NORMALIZATION, PlateStatus.COMPLETE_NORMALIZATION] },
    { "TAGMENTATION": [PlateStatus.START_TAGMENTATION, PlateStatus.COMPLETE_TAGMENTATION] },
    { "PURIFICATION": [PlateStatus.START_PURIFICATION, PlateStatus.COMPLETE_PURIFICATION] },
    { "INDEX_LIGATION": [PlateStatus.START_LIGATION, PlateStatus.COMPLETE_LIGATION] },
    { "CLEAN_UP": [PlateStatus.START_CLEAN_UP, PlateStatus.COMPLETE_CLEAN_UP] },
    { "LIBRARY_QC": [PlateStatus.START_LIB_QC, PlateStatus.COMPLETE_LIB_QC] }
  ]
  ngsBatchProcessStepMapStart = [PlateStatus.BATCH_UPLOADED, PlateStatus.BATCH_RECEIVED, PlateStatus.START_SAMPLE_QC, PlateStatus.START_NORMALIZATION, PlateStatus.START_TAGMENTATION, PlateStatus.START_LIGATION, PlateStatus.START_CLEAN_UP, PlateStatus.START_LIB_QC, PlateStatus.START_PURIFICATION]
  ngsBatchProcessStepMapComplete = [PlateStatus.PLATE_TRANSFERRED, PlateStatus.COMPLETE_SAMPLE_QC, PlateStatus.COMPLETE_NORMALIZATION, PlateStatus.COMPLETE_TAGMENTATION, PlateStatus.COMPLETE_LIGATION, PlateStatus.COMPLETE_CLEAN_UP, PlateStatus.COMPLETE_LIB_QC, PlateStatus.COMPLETE_PURIFICATION]
  batchProcessArray = [ProcessStep.RECEIVE_BATCH, ProcessStep.TRANSFER_PLATE, ProcessStep.SAMPLE_QC, ProcessStep.NORMALIZATION, ProcessStep.TAGMENTATION, ProcessStep.PURIFICATION, ProcessStep.INDEX_LIGATION, ProcessStep.CLEAN_UP, ProcessStep.LIBRARY_QC]
  allSelectedSamples: any[] = [];
  selectedPickedSample: any;
  sampleData: any;
  processDataList = [];
  isPlate: boolean = false;
  isBeadchip: boolean = false;
  isSample: boolean = false;
  isBatch: boolean = false;
  typeOfView: string = "PlateView";
  duplicateSamplesPresent: boolean = false;
  batchCommentsBoolean: boolean = false;
  sampleCommentsBoolean: boolean = false;
  plateComments: any[] = [];
  comments: any[] = [];
  excelData: any[] = [];
  commentsDisplayMap:Map<string, boolean> = new Map();
  newSampleComment: string = '';
  defaultDate = "1971-01-01T00:00:00Z"
  defaultDate2 = '1971-01-01 00:00:00.000'
  alwaysVisibleSampleValues = ["announced", "activated"]
  keysToBeFormatted = ['announcedDate', 'lastModifiedDate', "creationDate", "boxReceptionTimeStamp", "sampleUpdatedDate", "scanDate","birthDate","dueDate","requestedDate","sampleCreateDate","tatStartWeatherbys","closedDate","holdDate", "sampleCompletionDate"]
  unwantedSampleValues = ['storage', 'processed', 'barCode', 'plateProcessSteps', 'plateComments', 'comments', 'labId', 'puid', 'status', 'version', 'color', 'toBePicked','plated', 'plateHistory', 'lastModifiedDate', 'deliveryId', 'creationDate']
  noActionRequiredStatus = ['LYSIS_COMPLETED', 'WGA_COMPLETED',
    'FRAGMENTATION_COMPLETED', 'PRECIPITATION_COMPLETED', 'RESUSPENDING_COMPLETED',
    'DENATURATION_COMPLETED', 'COMPLETLY_TRANSFERED', 'INCUBATE_48C']

  keyRenameMap: Map<string, string> = new Map();
  searchDropdownOptions: any[];
  selectedDropdownValue : string;
  selectedPlateHistory: any;
  sampleTypeList = [];
  selectedSampleType: any;
  processFlowData: ProcessFlow[];
  sampleTypeAllowedStatuses = [PlateStatus.RECEIVED, PlateStatus.RECEPTION_COMPLETED, PlateStatus.QCSCAN_STARTED, PlateStatus.QCSCAN_COMPLETED];
  selectedPlateLastStep: string = "";


  @ViewChild('popUpRedoSelector') popUpRedoSelector: Dropdown;
  redoList = []
  hairRedoList = [
    { label: "Lysis Redo", value: { "redoLabel": "Lysis Redo", "redo": RedoType.LYSIS_REDO, "status": PlateStatus.PLATE_REDO, "stepName": "", "sampleType": "Hair" } },
    { label: "Extraction Redo", value: { "redoLabel": "Extraction Redo", "redo": RedoType.EXTRACTION_REDO, "status": PlateStatus.LYSIS_STARTED, "stepName": ProcessStep.EXTRACTION, "sampleType": "Hair" } },
    { label: "Aliquotation Redo", value: { "redoLabel": "Aliquotation Redo", "redo": RedoType.ALIQUOTATION_REDO, "status": PlateStatus.EXTRACTION_COMPLETED, "stepName": ProcessStep.ALIQUOTATION, "sampleType": "Hair" } }
  ]
  eartagRedoList = [
    { label: "Extraction Redo", value: { "redoLabel": "Extraction Redo", "redo": RedoType.EXTRACTION_REDO, "status": PlateStatus.LYSIS_COMPLETED, "stepName": ProcessStep.EXTRACTION, "sampleType": "Eartag" } },
    { label: "Aliquotation Redo", value: { "redoLabel": "Aliquotation Redo", "redo": RedoType.ALIQUOTATION_REDO, "status": PlateStatus.EXTRACTION_COMPLETED, "stepName": ProcessStep.ALIQUOTATION, "sampleType": "Eartag" } }
  ]
  tlrRedoList = [
    { label: "Aliquotation Redo", value: { "redoLabel": "Aliquotation Redo", "redo": RedoType.ALIQUOTATION_REDO, "status": PlateStatus.EXTRACTION_COMPLETED, "stepName": ProcessStep.ALIQUOTATION, "sampleType": "TLR" } }
  ]

  mergeRedoList = [
    { label: "Merge Redo", value: { "redoLabel":"Merge Redo"} }
  ]

  plateIDSelectionList = [
    { label: "CURRENT", value: { type:PlateIdTypes.LAST_UPDATED_PLATEID, key:"lastUpdatedPlateID" } },
    { label: "SOURCE", value: { type:PlateIdTypes.SOURCE, key:"plateID" } },
    { label: "LYSIS", value: { type:PlateIdTypes.LYSIS, key:"lysisPlateID" } },
    { label: "MAGMIX", value: { type:PlateIdTypes.MAGMIX, key:"magMixPlateID" } },
    { label: "DNA", value: { type:PlateIdTypes.DNA, key:"dnaPlateID" } },
    { label: "ALIQUOT", value: { type:PlateIdTypes.ALIQUOT, key:"aliquotPlateID" } },
    { label: "WGA", value: { type:PlateIdTypes.WGA, key:"wgaPlateID" } },
    { label: "PGX", value: { type:PlateIdTypes.PGX, key:"pgxPlateID" } },
  ];

  selectedPlateIDType: any = null;
  plateIDList = [];

  selectedRedoReason: any = ''
  multiUpdatePlateInfoList: PlateUpdateInfo[] = [];
  multiUpdatePlateList = [];
  multiUpdatePlateListSave: string[] = [];
  multiLiquidHandler: string = "";
  lastUpdatedStatus: string;
  sourcePlates = [];
  statusList = [];
  plateData: Plate;
  selectedStatus: any;
  sampleTypeAndProcessFlowNameMap: Map<string, string>;
  sampleIds = [];
  @ViewChild('idInput') idInput: ElementRef;
  plateIDSelectionDialog: boolean = false;
  clone = rfdc();
  popUpWithQCCheckForMergePlate: boolean = false;
  mergePlateRedoSelection: Array<any> = [];
  mergePlateRedoList: Array<Array<any>> = [];
  multiUpdateMergeRedoPlates: Map<string, Array<PlateUpdateInfo>> = new Map();


  constructor(
    private _messagesService: MessagesService,
    private adminSearchService: AdminSearchService,
    private announcementService:AnnouncedService,
    private platePreparationService: MaPlatePreparationService,
    private masterDataService: MasterDataService,
    private readonly resultEvaluationService: MaResultEvaluationService,
    private router: Router
  ) { }

  ngOnInit() {
    this.applicationProcess = localStorage.getItem('process');
    this.allowHistoryChangesRenderBasedOnRoleClaims()
    if (this.applicationProcess == 'ARRAY') {
      this.plateIDRegex = JSON.parse(localStorage.getItem("lab")).lab.plateIDRegex;
      this.beadchipIDRegex = JSON.parse(localStorage.getItem("lab")).lab.beadchipIDRegex;
    }
    else if (this.applicationProcess == 'NGS') {
      //Both batchID and plateID use the same regex which will be stored in plateIDRegex
      this.batchIDRegex = JSON.parse(localStorage.getItem("lab")).lab.plateIDRegex;
    }
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;

    this.puid = localStorage.getItem('PUID')
    this.searchedBatch = new Plate();
    this.selectedPlateStepsMap = new Map();
    this.showPlatePopup = false;
    this.showBeadchipPopup = false;
    this.showSamplePopup = false;

    this.mapOfPlateProcessStepsFlow.set(ProcessStep.AMPLIFY_WGA, [ProcessStep.RECEIVE_PLATE])
    this.mapOfPlateProcessStepsFlow.set(ProcessStep.AMPLIFY_PGX, [ProcessStep.RECEIVE_PLATE])
    this.mapOfPlateProcessStepsFlow.set(ProcessStep.RECOMBINE_DNA, [ProcessStep.AMPLIFY_WGA, ProcessStep.AMPLIFY_PGX])
    this.mapOfPlateProcessStepsFlow.set(ProcessStep.SAFE_STOPPING, [ProcessStep.RECOMBINE_DNA])
    this.mapOfPlateProcessStepsFlow.set(ProcessStep.FRAGMENT_DNA, [ProcessStep.RECOMBINE_DNA])
    this.mapOfPlateProcessStepsFlow.set(ProcessStep.PRECIPITATE_DNA, [ProcessStep.FRAGMENT_DNA])
    this.mapOfPlateProcessStepsFlow.set(ProcessStep.RESUSPEND_DNA, [ProcessStep.PRECIPITATE_DNA])
    this.mapOfPlateProcessStepsFlow.set(ProcessStep.DENATURATE_DNA, [ProcessStep.RESUSPEND_DNA])

    this.mapOfPlateProcessStepAndAction.set(ProcessStep.AMPLIFY_WGA, [Action.INCUBATE_WGA_RT, Action.INCUBATE_WGA_37C])
    this.mapOfPlateProcessStepAndAction.set(ProcessStep.PRECIPITATE_DNA, [Action.CENTRIFUGE, Action.MAX_DRYING_TIME])
    this.mapOfPlateProcessStepAndAction.set(ProcessStep.DENATURATE_DNA, [Action.INCUBATE_95C, Action.INCUBATE_RT])
    this.mapOfPlateProcessStepAndAction.set(ProcessStep.AMPLIFY_PGX, [Action.RUN_THERMO_CYCLER])
    this.mapOfPlateProcessStepAndAction.set(ProcessStep.FRAGMENT_DNA, [Action.INCUBATE_37C])
    this.mapOfPlateProcessStepAndAction.set(ProcessStep.RESUSPEND_DNA, [Action.INCUBATION_58C])

    //for beadchip
    this.mapOfBeadchipProcessStepsFlow.set(BeadChipProcessStep.HYBRIDIZATION, [BeadChipProcessStep.LOADING])
    this.mapOfBeadchipProcessStepsFlow.set(BeadChipProcessStep.WASHING, [BeadChipProcessStep.HYBRIDIZATION])
    this.mapOfBeadchipProcessStepsFlow.set(BeadChipProcessStep.EXTENSION, [BeadChipProcessStep.WASHING])
    this.mapOfBeadchipProcessStepsFlow.set(BeadChipProcessStep.COATING, [BeadChipProcessStep.EXTENSION])
    this.mapOfBeadchipProcessStepsFlow.set(BeadChipProcessStep.COMPLETED, [BeadChipProcessStep.COATING])

    this.mapOfBeadchipProcessStepAndAction.set(BeadChipProcessStep.COATING, [BeadChipAction.BEADCHIP_DRYING])
    this.mapOfBeadchipProcessStepAndAction.set(BeadChipProcessStep.HYBRIDIZATION, [BeadChipAction.TRANSFER_TO_CHAMBER])


    //for ngs batches
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.TRANSFER_PLATE, [ProcessStep.RECEIVE_BATCH]);
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.SAMPLE_QC, [ProcessStep.TRANSFER_PLATE]);
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.NORMALIZATION, [ProcessStep.SAMPLE_QC]);
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.TAGMENTATION, [ProcessStep.NORMALIZATION]);
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.PURIFICATION, [ProcessStep.TAGMENTATION]);
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.INDEX_LIGATION, [ProcessStep.PURIFICATION]);
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.CLEAN_UP, [ProcessStep.INDEX_LIGATION]);
    this.mapOfBatchesProcessStepsFlow.set(ProcessStep.LIBRARY_QC, [ProcessStep.CLEAN_UP]);

    this.keyRenameMap.set("boxReceptionTimeStamp", "receivedTimeStamp");
    this.keyRenameMap.set("position", "processPosition");
    this.keyRenameMap.set("sampleUpdatedDate","readyForProcessing");
    this.keyRenameMap.set("selectedSampleType","Assigned Sample Type");

    this.searchDropdownOptions = [
      { label: 'Animal Number', value : 'animalNumber' },
      { label: 'Barcode', value: 'barCode' },
      { label: 'Bottom Barcode', value: 'bottomBarcode' },
      { label: 'ITT Number', value: 'ittNumber' }
    ];

    this.selectedDropdownValue = 'barCode';
    this.getProcessFlowList();
    this.getSampleTypefromMDM()
  }

  allowHistoryChangesRenderBasedOnRoleClaims(){
    if(!environment.AZURE_LOGIN_NEEDED){
      this.canBeRenderedForGivenClaim = true;
      return;
    }
    const authUtil = new AuthUtil();
    const roles = authUtil.getRoleClaim(authUtil.getAccessToken())
    const matchedRoles = ALLOWED_ROLE_CLAIMS_FOR_HISTORY_CHANGES.filter(role => roles.includes(role))
    this.canBeRenderedForGivenClaim = matchedRoles.length !== 0;
  }

  getProcessFlowList(){
    this.masterDataService.getConfigList(this.selectedLabId, "processFlow", 0, 1000, true).subscribe(
      results => {
        this.processFlowData = results.data;
        this.isICBFWorkflow();
      }
    )
  }

  isICBFWorkflow(){
    let selectedWorkflow = JSON.parse(localStorage.getItem("selectedWorkFlow"));
    this.selectedProcessFlows = []
    this.sampleTypeAndProcessFlowNameMap = new Map();
    if(selectedWorkflow.processFlow == null || selectedWorkflow.processFlow.length==0 || this.processFlowData == undefined || this.processFlowData == null){
      return;
    }

    let selectedProcessFlowNames = selectedWorkflow.processFlow;
    this.processFlowData.forEach(
      processFlow => {
        if(selectedProcessFlowNames.includes(processFlow.processFlowName))
          this.selectedProcessFlows.push(processFlow);
          let sampleTypes = processFlow.sampleType.split(',');
          sampleTypes.forEach(sampleType => {
            this.sampleTypeAndProcessFlowNameMap.set(sampleType.trim(), processFlow.processFlowName);
          });
      }
    );
    if(this.selectedProcessFlows.length == 0){
      return;
    }
  }

  getSampleTypefromMDM() {
    this.sampleTypeList = [];
    this.selectedProcessFlows.forEach(processFlow => {
      let sampletypes = processFlow.sampleType.split(",").map(item => item.trim());
      sampletypes.forEach(sampletype=>{
        this.sampleTypeList.push({label:sampletype, value: sampletype})
      })

    });
  }

  resetValues(){
    this.duplicateSamplesPresent = false;
    this.blocked = false;
    this.newComment = ''
    this.newSampleComment = ''
    this.plateIDList = []
    this.selectedStatus = "";
    this.plateIDSelectionDialog = false;
    this.popUpWithQCCheckForMergePlate = false;
    this.multiUpdatePlateListSave = []
    this.multiUpdatePlateInfoList = []
    this.mergePlateRedoSelection = [];
    this.mergePlateRedoList = [];
    this.multiUpdateMergeRedoPlates = new Map();
  }

  setCommentsDisplay(key,value){
    this.commentsDisplayMap.set(key,value);
  }

  selectedSearch(searchID: string){
    if(searchID.includes('plate')){
      this.batchSelected = true
      this.typeOfView = "PlateView"
    }
    else if(searchID.includes('sample')){
      this.sampleSelected = true
      this.typeOfView = "SampleView"
    }
  }

  disabledInputField(){
    if(this.typeOfView == ''){
      return true
    }
    return false
  }

  regexMatcher(regex: string, searchID: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(searchID);
  }

  selectedSampleFromScan(sample){
    this.blocked = false;
    this.sampleHistoryModule(sample._id)
    this.duplicateSamplesPresent = false;
  }

  createProcessDataListWithNoActions(process) {
    let processData: SampleHistoryProcessSteps = new SampleHistoryProcessSteps();

    processData.plateId = process.lastUpdatedPlateID
    if(this.isSample){
      processData.position = process.position
    }
    processData.equipment = process.liquidHandler == null ? '' : process.liquidHandler
    processData.reagents = process.chemicals == null ? [] : process.chemicals
    processData.puid = process.endTimeStamp === null || process.endTimeStamp === this.defaultDate ? process.startPUID : process.endPUID
    processData.stepTime = process.endTimeStamp === null || process.endTimeStamp === this.defaultDate ? this.convertUtcToLocal(process.startTimeStamp) : this.convertUtcToLocal(process.endTimeStamp)
    if (process['step'] == 'NANODROP_FAIL') {
      processData.stepAction = process['step'] + ',' + process['status']
    }
    else {
      processData.stepAction = process['status'];
    }

    return processData;
  }

  createProcessDataListWithAction(process) {
    let processData: SampleHistoryProcessSteps = new SampleHistoryProcessSteps();

    processData.plateId = process.lastUpdatedPlateID
    if(this.isSample){
      processData.position = process.position
    }
    processData.stepAction = process['status'] + ',' + process.action[process.action.length - 1].action
    processData.stepTime = this.convertUtcToLocal(process.action[process.action.length - 1].actionStartTime)
    processData.equipment = process.action[process.action.length - 1].liquidHandler == null ? "" : process.action[process.action.length - 1].liquidHandler
    processData.reagents = process.action[process.action.length - 1].chemicals === null ? [] : process.action[process.action.length - 1].chemicals
    processData.puid = process.action[process.action.length - 1].actionPUID

    return processData;
  }

  sampleHistoryModule(sample_id: string) {
    this.blocked = true
    this.adminSearchService.getSampleHistory(this.selectedLabId, sample_id).subscribe({
      next: (result) => {
        this.blocked = false
        this.isSample = true;
        this.sampleData = result.data
        this.comments = this.sampleData.comments
        this.plateComments = this.sampleData.plateComments
        this.processDataList = []
        this.sampleData.plateProcessSteps.forEach((process, _index) => {

          if(process === null || process.status === null){
            return;
          }

          if (process['action'].length == 0 || this.noActionRequiredStatus.includes(process['status'])) {
            this.processDataList.push(this.createProcessDataListWithNoActions(process))
          }
          else {
            this.processDataList.push(this.createProcessDataListWithAction(process))
          }

        });
      },
      error: (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch sample history info',
          detail: "Sample History fetch failed"
        });
      }
    });
  }

  formatData(key, value){
    if(this.keysToBeFormatted.includes(key)){
      return this.convertUtcToLocal(value)
    }
    else{
      return value
    }
  }


  openBatchComments(){
    this.batchCommentsBoolean = true
  }

  openSampleComments(){
    this.sampleCommentsBoolean = true
  }


  getSteps(stepAction){
    return stepAction.split(',')
  }

  renameKeys(key){
    return this.keyRenameMap.has(key)? this.keyRenameMap.get(key) : key
  }

  checkIfUsableValueOrNot(item){
    if(this.alwaysVisibleSampleValues.includes(item.key)){
      return true
    }
    if(item.value == null){
      return false
    }
    if(item.value == ""){
      return false
    }
    if(item.value == this.defaultDate || item.value == this.defaultDate2){
      return false
    }
    return !this.unwantedSampleValues.includes(item.key)
  }


  exportAsExcelFile(json: any[]): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer);
  }

  saveAsExcelFile(buffer: any): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    let fileName;
    if(this.sampleData){
      fileName = this.sampleData.barCode
    }else{
      fileName = this.selectedPlate.plateID
    }
    fileSaver.saveAs(data, fileName + '_export' + EXCEL_EXTENSION);
  }


  convertData() {
    Object.assign(this.excelData, this.processDataList)
    this.excelData.forEach((element, index) => {
      let chemicalsString = ""
      if(element.reagents != undefined && element.reagents != null){
        element.reagents.forEach(element2 => {
          chemicalsString = chemicalsString == ""? chemicalsString + element2.chemical + ":"+ element2.lots.toString() : chemicalsString + ';' + element2.chemical + ":"+ element2.lots.toString()
        }, this);
      }
      this.excelData[index].reagents = chemicalsString
    }, this)
  }

  downloadExcelFile(){
    if(this.processDataList.length==0){
      this._messagesService.addWarningMessage({
        severity: "error",
        summary: "No process steps present",
        detail: "Please process the plate to download the file",
      });
      return;
    }
    this.convertData()
    this.exportAsExcelFile(this.excelData)
  }

  searchingSample(sampleID: string) {
    this.blocked = true
    this.announcementService.getSelectedSampleFromDelivery(this.selectedLabId,sampleID, this.selectedDropdownValue).subscribe({ next : (result) => {
      this.blocked = false
      this.allSelectedSamples = result.data
      if(result.data.length>1){
        this.duplicateSamplesPresent = true
      }
      else if(result.data.length == 1){
        let sample = result.data[0]
        let sample_id = sample['_id']
        this.sampleHistoryModule(sample_id)
      }
    },error: (error: any) => {
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Failed to fetch sample info',
        detail: error.error.error
      })
    }
    })
  }

  searchingBatchID(batchId: string) {
    this.adminSearchService.getBatchForLabAndBatchId(this.selectedLabId, this.fieldBatchID, batchId).subscribe({
      next : (result) => {
        if (result.data == undefined) {
          this._messagesService.addErrorMessage({
            severity: 'error', detail: 'Batch ' + batchId + ' not found', summary: 'No batch found'
          })
          this.isBatch = false;
          return
        }
        this.selectedBatch = result.data
        this.selectedBatchBatchID = this.selectedBatch.batchID
        this.selectedBatchSender = this.selectedBatch.sender
        this.selectedBatchStatus = this.selectedBatch.statusOfTheBatch
        this.selectedBatchComments = this.selectedBatch.comments
        this.batchCommentsList = this.selectedBatchComments
      },
      error: (error: any) => {
        if (error.status == 404) {
          this._messagesService.addErrorMessage({
            severity: 'error', detail: 'Batch ' + batchId + ' not found', summary: 'No batch found'
          })
        } else {
          this._messagesService.addErrorMessage({
            severity: 'error', detail: 'Unknown error, please try again'
          })
        }
        this.isBatch = false;
      }
    })
  }

  searchingBeadchip(beadChipID: string, type: string) {
    this.adminSearchService.fetchPlateByIDandLab(this.selectedLabId, beadChipID, type).subscribe({
      next: (result) => {
        this.selectedPlate = result;
        this.searchedBeadchipID = beadChipID;
        this.beadchipStatus = this.selectedPlate.status
      },
      error: (error)=>{
        this.searchedBeadchipID = ''
        this.beadchipStatus = ''
        this.isBeadchip = false;
        if (error.status == 404) {
          this._messagesService.addErrorMessage({
            severity: 'error', detail: 'Beadchip ' + beadChipID + ' not found', summary: 'No beadchip found'
          })
        } else {
          this._messagesService.addErrorMessage({
            severity: 'error', detail: 'Unknown error, please try again'
          })
        }
      }
    });
  }

  disableSearchIf(searchID: string): boolean {
    return !searchID || searchID.trim() == "";
  }

  disableCommentIf(comment: string): boolean {
    return !comment || comment.trim() == "";
  }

  getCommentDTO() {
    let newComment: CommentDTO = new CommentDTO();
    newComment.puid = this.puid;
    newComment.labid = this.selectedLabId;
    newComment.comment = this.newComment;
    //plateComment determines it is a plate or a beadChip
    newComment.platecomment = true;
    newComment.beadchipid = "";
    newComment.beadchipstatus = "";
    newComment.plateid = this.selectedPlateID;
    newComment.status = this.selectedPlateStatus;
    return newComment;
  }


  getSampleCommentDTO(){
    let newComment = new SampleCommentDTO;
    newComment.puid = this.puid;
    newComment.status = "ADMIN_CHANGE";
    newComment.comment = this.newSampleComment;
    return newComment;
  }

  saveSampleComment(){
    this.announcementService.updateSampleComment(this.selectedLabId, this.sampleData._id.toString(), this.getSampleCommentDTO()).subscribe({
      next : (result) => {
        this.newSampleComment = "";
        this.sampleCommentsBoolean = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result.data })
      },
      error: (error: any) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  saveComment() {
    if (this.tempStatus == '') {
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'Status not selected', summary: 'Please select a status'
      })
      return
    }
    this.adminSearchService.updateComment(this.getCommentDTO()).subscribe({
      next: (result) => {
        this.newComment = "";
        this.batchCommentsBoolean = false
        this.updateStatus()
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
      },
      error: (error) => {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
        }
      }
    )
  }

  saveBatchComment(event) {
    if (this.tempStatus == '') {
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'Status not selected', summary: 'Please select a status'
      })
      return
    }
    this.batchComment = {
      userComment: event,
      batchId: this.selectedBatchBatchID,
      puid: this.puid,
      commentDate: new Date()
    }
    this.updateStatus()
  }

  savePlateComment() {
    if(this.sampleData.sourcePlateID == null){
      this._messagesService.addErrorMessage({
        severity: 'error',
        summary: 'Sample not placed on a plate yet',
        detail: "Sample not placed on a plate yet"
      })
      return
    }
    let newComment: CommentDTO = new CommentDTO();
    newComment.puid = this.puid;
    newComment.labid = this.selectedLabId;
    newComment.comment = this.newComment;
    //plateComment determines it is a plate or a beadChip
    newComment.platecomment = true;
    newComment.beadchipid = "";
    newComment.beadchipstatus = "";
    newComment.plateid = this.sampleData.sourcePlateID;
    newComment.status = "ADMIN_CHANGE";
    this.adminSearchService.updateComment(newComment).subscribe({
      next: (result) => {
        this.newComment = "";
        this.batchCommentsBoolean = false
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
      },
      error: (error) => {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
        }
      }
    )
  }

  showPlate() {
    if (this.plateId && this.plateId.trim() !== '') {
      var queryParams = {
        plateID: this.plateId
      }
      this.router.navigate(['/samples'], { queryParams: queryParams })
    }
  }

  showBeadchip() {
    if (this.searchedBeadchipID && this.searchedBeadchipID.trim() !== '') {
      var queryParams = {
        beadchipID: this.searchedBeadchipID
      }
      this.router.navigate(['/samples'], { queryParams: queryParams })
    }
  }

  updatedStatusFun(status: string) {
    this.tempStatus = status
  }

  statusUpdateCheck() {
    this.statusUpdate = !this.statusUpdate
  }

  setBeadchipDisplay(beadChip: string, bool: boolean) {
    this.beadChipCommentsDisplayMap.set(beadChip, bool);
  }

  convertUtcToLocal(date: Date) {
    if (!date || date == null) return;
    var offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes() - offset);
    let dateFormated = ""
    dateFormated = dateFormated + dateInLocal.toISOString().split('T')[0]
    dateFormated = dateFormated + " " + dateInLocal.toISOString().split('T')[1].split('Z')[0]
    return dateFormated;
  }

  showComments() {
    this.beadChipCommentsDisplayMap.clear();
    this.beadChipCommentsDisplayMap.set("showPlateCommentList", false)
    this.beadChipCommentsMap.clear();

    this.updatedStatus = this.tempStatus

    if (this.tempStatus == '') {
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'Status not selected', summary: 'Please select a status'
      })
      return
    }

      this.adminSearchService.commentDetailsbyPlateId(this.selectedLabId, this.selectedPlate.plateID).subscribe({
        next: (result) => {
          this.fetchedCommentsPlate = result;
          this.selectedPlateID = this.fetchedCommentsPlate.plateID;
          this.selectedPlateStatus = this.selectedPlate.status;
          this.selectedBeadChipID = this.fetchedCommentsPlate.plateID;
          this.plateCommentsList = this.fetchedCommentsPlate.comments;
          if(this.fetchedCommentsPlate && this.fetchedCommentsPlate.beadChips){
            this.fetchedCommentsPlate.beadChips.forEach(beadChip=>{
              this.beadChipCommentsMap.set(beadChip.beadChipID,beadChip.comments)
              this.beadChipCommentsDisplayMap.set(beadChip.beadChipID,false);
            })
          }
          this.showCommentDialog = true;
          this.commentStatusSet = true
        },
        error: (error) => {
            this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
          }
        }
      )
  }

  hideDialog() {
    this.showCommentDialog = false;
  }


  updatePlateStatus(selectedPlateProcessSteps, resettedPlateProcessSteps, archivedPlateProcessSteps, array, selectedProcessStep) {
    let lastCurrentProcessStep
    let newProcessStepActions

    lastCurrentProcessStep = selectedPlateProcessSteps[selectedPlateProcessSteps.length - 1]

    //Will have the last processStep in the plate selected
    lastCurrentProcessStep = lastCurrentProcessStep ? lastCurrentProcessStep.step : ''
    this.selectedPlate.status = this.updatedStatus
    for (let key in this.arrayPlateProcessStatusMaps) {
      Object.entries(this.arrayPlateProcessStatusMaps[key]).forEach(([key2, value2]) => {
        if (value2.includes(this.updatedStatus)) {
          selectedProcessStep = key2
        }
        array.push(value2)
      }, this)
    }

    let selectedStatusIndex = this.calculateSelectedStatusIndex(array)

    let statusProcessStep = this.calculateStatusProcessStep(selectedStatusIndex, selectedPlateProcessSteps, selectedProcessStep)


    if (this.statusPlateProcessStepMapStart.includes(this.updatedStatus)) {
      if (this.plateProcessArray.indexOf(selectedProcessStep) >= this.plateProcessArray.indexOf(lastCurrentProcessStep)) {
        newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(statusProcessStep.step)
        let actionsOfProcessStep = this.mapOfPlateProcessStepAndAction.get(this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step)
        let tempActionsPlateStart = []
        if (actionsOfProcessStep != undefined) {
          actionsOfProcessStep.forEach(function (item2, index2) {
            let temp = {
              "action": item2,
              "actionStartTime": new Date(),
              "actionPUID": this.puid,
              "actionRunTime": 0
            }
            tempActionsPlateStart.push(temp)
          }, this)
        }
        let remainingProcessStepList = this.calculateRemainingProcessStepList(selectedProcessStep, lastCurrentProcessStep, ProcessStep.RECEIVE_PLATE, this.mapOfPlateProcessStepsFlow)

        this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1] = {
          action: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action.length>0 ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action : tempActionsPlateStart.length > 0 ? tempActionsPlateStart : [],
          chemicals: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals : [],
          endPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID : this.puid,
          endTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp : null,
          liquidHandler: "",
          startPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID : this.puid,
          startTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp : null,
          step: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step,
        }

        remainingProcessStepList.reverse().forEach(function (item, index) {
          let processCurrent
          if (!this.mapOfPlateProcessStepAndAction.has(ProcessStep.RECOMBINE_DNA)) {
            let actionsOfProcessStep = this.mapOfPlateProcessStepAndAction.get(item)
            let tempActions = []
            if (actionsOfProcessStep != undefined) {
              actionsOfProcessStep.forEach(function (item2, index2) {
                let temp = {
                  "action": item2,
                  "actionStartTime": new Date(),
                  "actionPUID": this.puid,
                  "actionRunTime": 0
                }
                tempActions.push(temp)
              }, this)
            }

            processCurrent = {
              action: actionsOfProcessStep != undefined ? tempActions : [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: statusProcessStep == undefined ? this.puid : statusProcessStep.startPUID,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
          else {
            processCurrent = {
              action: [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: statusProcessStep == undefined ? this.puid : statusProcessStep.startPUID,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
        }, this)

        this.processCurrent = {
          action: [],
          chemicals: [],
          endPUID: "",
          endTimeStamp: null,
          liquidHandler: "",
          startPUID: this.puid,
          startTimeStamp: new Date(),
          step: statusProcessStep == undefined ? 'RECEIVE_PLATE' : statusProcessStep.step
        }
        this.selectedPlate.processSteps.push(this.processCurrent)
      }
      else {
        resettedPlateProcessSteps = selectedPlateProcessSteps.slice(0, selectedStatusIndex)

        resettedPlateProcessSteps = this.updatePlateProcessStepsBasedOnProcessStepsStart(resettedPlateProcessSteps, statusProcessStep, selectedProcessStep)

        archivedPlateProcessSteps = selectedPlateProcessSteps.slice(selectedStatusIndex,)
        this.selectedPlate.processSteps = resettedPlateProcessSteps
      }
    }
    else if (this.statusPlateProcessStepMapComplete.includes(this.updatedStatus)) {
      if (this.plateProcessArray.indexOf(selectedProcessStep) >= this.plateProcessArray.indexOf(lastCurrentProcessStep)) {
        newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(statusProcessStep.step)
        let tempActions = []

        let remainingProcessStepList = this.calculateRemainingProcessStepList(selectedProcessStep, lastCurrentProcessStep, ProcessStep.RECEIVE_PLATE, this.mapOfPlateProcessStepsFlow)

        let tempActionsPlateComplete = []
        if (!this.mapOfPlateProcessStepAndAction.has(ProcessStep.RECOMBINE_DNA)) {
          let actionsOfProcessStep = this.mapOfPlateProcessStepAndAction.get(this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step)
          if (actionsOfProcessStep != undefined) {
            actionsOfProcessStep.forEach(function (item2, index2) {
              let temp = {
                "action": item2,
                "actionStartTime": new Date(),
                "actionPUID": this.puid,
                "actionRunTime": 0
              }
              tempActionsPlateComplete.push(temp)
            }, this)
          }
        }

        this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1] = {
          action: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action.length>0 ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action : tempActionsPlateComplete.length > 0 ? tempActionsPlateComplete : [],
          chemicals: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals : [],
          endPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID : this.puid,
          endTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp : null,
          liquidHandler: "",
          startPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID : this.puid,
          startTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp : null,
          step: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step,
        }

        remainingProcessStepList.reverse().forEach(function (item, index) {
          let processCurrent
          if (!this.mapOfPlateProcessStepAndAction.has(ProcessStep.RECOMBINE_DNA)) {
            let actionsOfProcessStep = this.mapOfPlateProcessStepAndAction.get(item)
            let tempActions = []
            if (actionsOfProcessStep != undefined) {
              actionsOfProcessStep.forEach(function (item2, index2) {
                let temp = {
                  "action": item2,
                  "actionStartTime": new Date(),
                  "actionPUID": this.puid,
                  "actionRunTime": 0
                }
                tempActions.push(temp)
              }, this)
            }

            processCurrent = {
              action: actionsOfProcessStep != undefined ? tempActions : [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: this.puid,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
          else {
            processCurrent = {
              action: [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: this.puid,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
        }, this)


        if (newProcessStepActions != undefined) {
          newProcessStepActions.forEach(function (item, index) {
            let temp = {
              "action": item,
              "actionStartTime": new Date(),
              "actionPUID": this.puid,
              "actionRunTime": 0
            }
            tempActions.push(temp)
          }, this);

        }
        this.processCurrent = {
          action: newProcessStepActions != undefined ? tempActions : [],
          chemicals: [],
          endPUID: this.puid,
          endTimeStamp: new Date(),
          liquidHandler: "",
          startPUID: statusProcessStep == undefined ? this.puid : statusProcessStep.startPUID,
          startTimeStamp: statusProcessStep == undefined ? new Date() : statusProcessStep.startTimeStamp,
          step: statusProcessStep == undefined ? 'RECEIVE_PLATE' : statusProcessStep.step
        }
        this.selectedPlate.processSteps.push(this.processCurrent)
      }
      else {
        newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(statusProcessStep.step)
        resettedPlateProcessSteps = selectedPlateProcessSteps.slice(0, selectedStatusIndex)
        let tempActions2 = []
        if (statusProcessStep.step == ProcessStep.AMPLIFY_WGA || statusProcessStep.step == ProcessStep.AMPLIFY_PGX) {
          resettedPlateProcessSteps = resettedPlateProcessSteps.slice(0, 1)
          resettedPlateProcessSteps = this.updatePlateProcessStepsBasedOnProcessStepsComplete(resettedPlateProcessSteps, newProcessStepActions)
        }
        else {
          if (newProcessStepActions != undefined) {
            newProcessStepActions.forEach(function (item, index) {
              let temp = {
                "action": item,
                "actionStartTime": new Date(),
                "actionPUID": this.puid,
                "actionRunTime": 0
              }
              tempActions2.push(temp)
            }, this);
          }
          this.processCurrent = {
            action: newProcessStepActions != undefined ? tempActions2 : [],
            chemicals: [],
            endPUID: this.puid,
            endTimeStamp: new Date(),
            liquidHandler: "",
            startPUID: this.puid,
            startTimeStamp: null,
            step: selectedProcessStep
          }
          resettedPlateProcessSteps.push(this.processCurrent)
        }
        archivedPlateProcessSteps = selectedPlateProcessSteps.slice(selectedStatusIndex,)
        this.selectedPlate.processSteps = resettedPlateProcessSteps
      }

    }

    this.updatePlateArchiveData(archivedPlateProcessSteps)


    // For plate
    this.adminSearchService.saveUpdatedStatus(this.selectedLabId, this.searchedText, this.selectedPlate).subscribe({
      next: (_result) => {
        this.statusUpdated = true;
        this.commentStatusSet = false;
        this.updatedStatus = '';
        this.tempStatus = '';
        this.newComment = '';
        this.isPlate = false;
        this.showCommentDialog = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Plate Status Updated Successfully' })
      },
      error: (error) => {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
        }
      }
    );
  }

  updateBeadChipStatus(selectedPlateProcessSteps, resettedPlateProcessSteps, archivedPlateProcessSteps, array, selectedProcessStep) {
    let lastCurrentProcessStep
    let newProcessStepActions

    lastCurrentProcessStep = selectedPlateProcessSteps[selectedPlateProcessSteps.length - 1]

    //Will have the last processStep in the plate selected
    lastCurrentProcessStep = lastCurrentProcessStep ? lastCurrentProcessStep.step : ''
    this.selectedPlate.status = this.updatedStatus
    for (let key in this.arrayBeadchipProcessStatusMaps) {
      Object.entries(this.arrayBeadchipProcessStatusMaps[key]).forEach(([key2, value2]) => {
        if (value2.includes(this.updatedStatus)) {
          selectedProcessStep = key2
        }
        array.push(value2)
      }, this)
    }


    let selectedStatusIndex = this.calculateSelectedStatusIndex(array)

    let statusProcessStep = this.calculateStatusProcessStep(selectedStatusIndex, selectedPlateProcessSteps, selectedProcessStep)



    if (this.statusBeadProcessStepMapStart.includes(this.updatedStatus)) {
      if (this.beadchipProcessArray.indexOf(selectedProcessStep) >= this.beadchipProcessArray.indexOf(lastCurrentProcessStep)) {
        newProcessStepActions = this.mapOfBeadchipProcessStepAndAction.get(statusProcessStep.step)
        let remainingProcessStepList = this.calculateRemainingProcessStepList(selectedProcessStep, lastCurrentProcessStep, BeadChipProcessStep.LOADING, this.mapOfBeadchipProcessStepsFlow)

        let actionsOfProcessStep = this.mapOfBeadchipProcessStepAndAction.get(this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step)
        let tempActionsBeadStart = []
        if (actionsOfProcessStep != undefined) {
          actionsOfProcessStep.forEach(function (item2, index2) {
            let temp = {
              "action": item2,
              "actionStartTime": new Date(),
              "actionPUID": this.puid,
              "actionRunTime": 0
            }
            tempActionsBeadStart.push(temp)
          }, this)
        }

        this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1] = {
          action: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action.length>0 ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action : tempActionsBeadStart.length > 0 ? tempActionsBeadStart : [],
          chemicals: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals : [],
          endPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID : this.puid,
          endTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp : null,
          liquidHandler: "",
          startPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID : this.puid,
          startTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp : null,
          step: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step,
        }

        remainingProcessStepList.reverse().forEach(function (item, index) {
          let processCurrent
          if (this.mapOfBeadchipProcessStepAndAction.has(BeadChipProcessStep.COATING) || this.mapOfBeadchipProcessStepAndAction.has(BeadChipProcessStep.HYBRIDIZATION)) {
            let actionsOfProcessStep = this.mapOfBeadchipProcessStepAndAction.get(item)
            let tempActions = []
            if (actionsOfProcessStep != undefined) {
              actionsOfProcessStep.forEach(function (item2, index2) {
                let temp = {
                  "action": item2,
                  "actionStartTime": new Date(),
                  "actionPUID": this.puid,
                  "actionRunTime": 0
                }
                tempActions.push(temp)
              }, this)
            }

            processCurrent = {
              action: actionsOfProcessStep != undefined ? tempActions : [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: statusProcessStep == undefined ? this.puid : statusProcessStep.startPUID,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
          else {
            processCurrent = {
              action: [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: statusProcessStep == undefined ? this.puid : statusProcessStep.startPUID,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
        }, this)


        this.processCurrent = {
          action: [],
          chemicals: [],
          endPUID: "",
          endTimeStamp: null,
          liquidHandler: "",
          startPUID: this.puid,
          startTimeStamp: new Date(),
          step: statusProcessStep.step
        }
        this.selectedPlate.processSteps.push(this.processCurrent)
      }
      else {
        resettedPlateProcessSteps = selectedPlateProcessSteps.slice(0, selectedStatusIndex)

        this.processCurrent = {
          action: [],
          chemicals: [],
          endPUID: "",
          endTimeStamp: null,
          liquidHandler: "",
          startPUID: this.puid,
          startTimeStamp: new Date(),
          step: selectedProcessStep
        }
        resettedPlateProcessSteps.push(this.processCurrent)
        archivedPlateProcessSteps = selectedPlateProcessSteps.slice(selectedStatusIndex,)
        this.selectedPlate.processSteps = resettedPlateProcessSteps
      }

    }
    else if (this.statusBeadProcessStepMapComplete.includes(this.updatedStatus)) {
      if (this.beadchipProcessArray.indexOf(selectedProcessStep) >= this.beadchipProcessArray.indexOf(lastCurrentProcessStep)) {
        newProcessStepActions = this.mapOfBeadchipProcessStepAndAction.get(statusProcessStep.step)
        let actionsOfProcessStep = this.mapOfBeadchipProcessStepAndAction.get(this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step)
        let tempActionsBeadComplete = []
        if (actionsOfProcessStep != undefined) {
          actionsOfProcessStep.forEach(function (item2, index2) {
            let temp = {
              "action": item2,
              "actionStartTime": new Date(),
              "actionPUID": this.puid,
              "actionRunTime": 0
            }
            tempActionsBeadComplete.push(temp)
          }, this)
        }

        let remainingProcessStepList = this.calculateRemainingProcessStepList(selectedProcessStep, lastCurrentProcessStep, BeadChipProcessStep.LOADING, this.mapOfBeadchipProcessStepsFlow)

        this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1] = {
          action: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action.length>0 ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].action : tempActionsBeadComplete.length > 0 ? tempActionsBeadComplete : [],
          chemicals: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].chemicals : [],
          endPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endPUID : this.puid,
          endTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].endTimeStamp : null,
          liquidHandler: "",
          startPUID: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startPUID : this.puid,
          startTimeStamp: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp ? this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].startTimeStamp : null,
          step: this.selectedPlate.processSteps[this.selectedPlate.processSteps.length - 1].step,
        }

        remainingProcessStepList.reverse().forEach(function (item, index) {
          let processCurrent

          if (this.mapOfBeadchipProcessStepAndAction.has(BeadChipProcessStep.COATING) || this.mapOfBeadchipProcessStepAndAction.has(BeadChipProcessStep.HYBRIDIZATION)) {
            let actionsOfProcessStep = this.mapOfBeadchipProcessStepAndAction.get(item)
            let tempActions = []
            if (actionsOfProcessStep != undefined) {
              actionsOfProcessStep.forEach(function (item2, index2) {
                let temp = {
                  "action": item2,
                  "actionStartTime": new Date(),
                  "actionPUID": this.puid,
                  "actionRunTime": 0
                }
                tempActions.push(temp)
              }, this)
            }

            processCurrent = {
              action: actionsOfProcessStep != undefined ? tempActions : [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: this.puid,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
          else {
            processCurrent = {
              action: [],
              chemicals: [],
              endPUID: this.puid,
              endTimeStamp: null,
              liquidHandler: "",
              startPUID: this.puid,
              startTimeStamp: null,
              step: item
            }
            this.selectedPlate.processSteps.push(processCurrent)
          }
        }, this)

        let tempActions2 = []
        if (newProcessStepActions != undefined) {
          newProcessStepActions.forEach(function (item, index) {
            let temp = {
              "action": item,
              "actionStartTime": new Date(),
              "actionPUID": this.puid,
              "actionRunTime": 0
            }
            tempActions2.push(temp)
          }, this);
        }

        this.processCurrent = {
          action: newProcessStepActions != undefined && selectedProcessStep != BeadChipProcessStep.COATING ? tempActions2 : [],
          chemicals: [],
          endPUID: this.puid,
          endTimeStamp: new Date(),
          liquidHandler: "",
          startPUID: statusProcessStep.startPUID,
          startTimeStamp: selectedProcessStep == BeadChipProcessStep.COATING ? statusProcessStep.startTimeStamp ? statusProcessStep.startTimeStamp : new Date() : null,
          step: statusProcessStep.step
        }
        this.selectedPlate.processSteps.push(this.processCurrent)
      }
      else {
        newProcessStepActions = this.mapOfBeadchipProcessStepAndAction.get(statusProcessStep.step)
        resettedPlateProcessSteps = selectedPlateProcessSteps.slice(0, selectedStatusIndex)
        let tempActions = []
        if (newProcessStepActions != undefined) {
          newProcessStepActions.forEach(function (item, index) {
            let temp = {
              "action": item,
              "actionStartTime": new Date(),
              "actionPUID": this.puid,
              "actionRunTime": 0
            }
            tempActions.push(temp)
          }, this);
        }
        this.processCurrent = {
          action: newProcessStepActions != undefined ? tempActions : [],
          chemicals: [],
          endPUID: this.puid,
          endTimeStamp: new Date(),
          liquidHandler: "",
          startPUID: this.puid,
          startTimeStamp: null,
          step: selectedProcessStep
        }
        resettedPlateProcessSteps.push(this.processCurrent)
        archivedPlateProcessSteps = selectedPlateProcessSteps.slice(selectedStatusIndex,)
        this.selectedPlate.processSteps = resettedPlateProcessSteps
      }

    }

    this.updatePlateArchiveData(archivedPlateProcessSteps)


    // For beadchip
    this.adminSearchService.saveUpdatedStatus(this.selectedLabId, this.searchedText, this.selectedPlate).subscribe({
      next: (_result) => {
        this.statusUpdated = true;
        this.commentStatusSet = false;
        this.updatedStatus = '';
        this.newComment = '';
        this.tempStatus = '';
        this.isBeadchip = false;
        this.showCommentDialog = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Beadchip Status Updated Successfully' });
      },
       error: (error) => {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
        }
      }
  );
}

  updateBatchStatus(selectedPlateProcessSteps, resettedPlateProcessSteps, archivedPlateProcessSteps, array, selectedProcessStep) {
    let lastCurrentProcessStep

    lastCurrentProcessStep = selectedPlateProcessSteps[selectedPlateProcessSteps.length - 1]

    //Will have the last processStep in the plate selected
    lastCurrentProcessStep = lastCurrentProcessStep ? lastCurrentProcessStep.step : ''
    this.selectedBatch.statusOfTheBatch = this.updatedStatus
    for (let key in this.ngsBatchProcessStatusMaps) {
      Object.entries(this.ngsBatchProcessStatusMaps[key]).forEach(
        ([key2, value2]) => {
          if (value2.includes(this.updatedStatus)) {
            selectedProcessStep = key2
          }
          array.push(value2)
        }
      )
    }

    let selectedStatusIndex = this.calculateSelectedStatusIndexBatch(array)

    let statusProcessStep = this.calculateStatusProcessStep(selectedStatusIndex, selectedPlateProcessSteps, selectedProcessStep)


    if (this.ngsBatchProcessStepMapStart.includes(this.updatedStatus)) {
      if (this.batchProcessArray.indexOf(selectedProcessStep) >= this.batchProcessArray.indexOf(lastCurrentProcessStep)) {

        let remainingProcessStepList = this.calculateRemainingProcessStepList(selectedProcessStep, lastCurrentProcessStep, ProcessStep.RECEIVE_BATCH, this.mapOfBatchesProcessStepsFlow)

        this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1] = {
          action: [],
          chemicals: [],
          endPUID: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endPUID ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endPUID : this.puid,
          endTimeStamp: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endTimeStamp ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endTimeStamp : null,
          liquidHandler: "",
          startPUID: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startPUID ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startPUID : this.puid,
          startTimeStamp: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startTimeStamp ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startTimeStamp : null,
          step: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].step
        }


        remainingProcessStepList.reverse().forEach(function (item, index) {
          let processCurrent
          processCurrent = {
            action: [],
            chemicals: [],
            endPUID: this.puid,
            endTimeStamp: null,
            liquidHandler: "",
            startPUID: statusProcessStep == undefined ? this.puid : statusProcessStep.startPUID,
            startTimeStamp: null,
            step: item
          }
          this.selectedBatch.processSteps.push(processCurrent)
        }, this)

        this.processCurrent = {
          action: [],
          chemicals: [],
          endPUID: "",
          endTimeStamp: null,
          liquidHandler: "",
          startPUID: this.puid,
          startTimeStamp: new Date(),
          step: statusProcessStep == undefined ? 'RECEIVE_PLATE' : statusProcessStep.step
        }
        this.selectedBatch.processSteps.push(this.processCurrent)

      }
      else {
        resettedPlateProcessSteps = selectedPlateProcessSteps.slice(0, selectedStatusIndex)
        this.processCurrent = {
          action: [],
          chemicals: [],
          endPUID: "",
          endTimeStamp: null,
          liquidHandler: "",
          startPUID: this.puid,
          startTimeStamp: new Date(),
          step: selectedProcessStep
        }
        resettedPlateProcessSteps.push(this.processCurrent)
        archivedPlateProcessSteps = selectedPlateProcessSteps.slice(selectedStatusIndex,)

        this.selectedBatch.processSteps = resettedPlateProcessSteps

      }
    }
    else if (this.ngsBatchProcessStepMapComplete.includes(this.updatedStatus)) {

      if (this.batchProcessArray.indexOf(selectedProcessStep) >= this.batchProcessArray.indexOf(lastCurrentProcessStep)) {
        let remainingProcessStepList = this.calculateRemainingProcessStepList(selectedProcessStep, lastCurrentProcessStep, ProcessStep.RECEIVE_BATCH, this.mapOfBatchesProcessStepsFlow)

        this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1] = {
          action: [],
          chemicals: [],
          endPUID: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endPUID ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endPUID : this.puid,
          endTimeStamp: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endTimeStamp ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].endTimeStamp : null,
          liquidHandler: "",
          startPUID: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startPUID ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startPUID : this.puid,
          startTimeStamp: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startTimeStamp ? this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].startTimeStamp : null,
          step: this.selectedBatch.processSteps[this.selectedBatch.processSteps.length - 1].step
        }

        remainingProcessStepList.reverse().forEach(function (item, index) {
          let processCurrent
          processCurrent = {
            action: [],
            chemicals: [],
            endPUID: this.puid,
            endTimeStamp: null,
            liquidHandler: "",
            startPUID: statusProcessStep == undefined ? this.puid : statusProcessStep.startPUID,
            startTimeStamp: null,
            step: item
          }
          this.selectedBatch.processSteps.push(processCurrent)
        }, this)

        this.processCurrent = {
          action: [],
          chemicals: [],
          endPUID: this.puid,
          endTimeStamp: new Date(),
          liquidHandler: "",
          startPUID: this.puid,
          startTimeStamp: null,
          step: selectedProcessStep
        }
        this.selectedBatch.processSteps.push(this.processCurrent)

      }
      else {
        resettedPlateProcessSteps = selectedPlateProcessSteps.slice(0, selectedStatusIndex)
        this.processCurrent = {
          action: [],
          chemicals: [],
          endPUID: this.puid,
          endTimeStamp: new Date(),
          liquidHandler: "",
          startPUID: selectedPlateProcessSteps.slice(selectedStatusIndex, selectedStatusIndex + 1)[0].startPUID,
          startTimeStamp: selectedPlateProcessSteps.slice(selectedStatusIndex, selectedStatusIndex + 1)[0].startTimeStamp ? selectedPlateProcessSteps.slice(selectedStatusIndex, selectedStatusIndex + 1)[0].startTimeStamp : "",
          step: selectedProcessStep
        }
        resettedPlateProcessSteps.push(this.processCurrent)
        archivedPlateProcessSteps = selectedPlateProcessSteps.slice(selectedStatusIndex,)

        this.selectedBatch.processSteps = resettedPlateProcessSteps

      }
    }

    this.updateBatchArchiveDataAndComments(archivedPlateProcessSteps)


    //Saving Updated Batch
    this.adminSearchService.saveSampleData(this.selectedBatch, 1, 1).subscribe({
      next : (_result) => {
        this.statusUpdated = true
        this.batchComment.batchId = ''
        this.batchComment.puid = ''
        this.batchComment.commentDate = null
        this.batchComment.userComment = ''
        this.updatedStatus = ''
        this.newComment = ''
        this.tempStatus = ''
        this.isBatch = false
        this.showCommentDialog = false
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Batch Status Updated Successfully' })
      },
      error: (error: any) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    })
  }

  calculateSelectedStatusIndex(array) {
    // Function to calculate the index of the selected process step

    let selectedStatusIndex = -1
    array.forEach(function (value, index) {
      if (value.map(name => name.toLowerCase()).includes(this.updatedStatus.toLowerCase())) {
        selectedStatusIndex = array.indexOf(value)
      }
    }, this)

    return selectedStatusIndex
  }


  calculateStatusProcessStep(selectedStatusIndex, selectedPlateProcessSteps, selectedProcessStep) {
    let statusProcessStep

    //For forward selection of status
    if (selectedStatusIndex != undefined && selectedStatusIndex != -1 && selectedStatusIndex < selectedPlateProcessSteps.length) {
      statusProcessStep = selectedPlateProcessSteps[selectedStatusIndex]
    }
    else {
      statusProcessStep = {
        action: [],
        chemicals: [],
        endPUID: "",
        endTimeStamp: null,
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: null,
        step: selectedProcessStep
      }
    }

    return statusProcessStep
  }


  calculateRemainingProcessStepList(selectedProcessStep, lastCurrentProcessStep, plateTypeFirstProcessStep, mapOfProcessSteps) {
    //Function to return a list of process steps which need to be appended to the ProcessSteps

    let userSelectedProcessStep = selectedProcessStep
    let remainingProcessStepList = []
    remainingProcessStepList.push(userSelectedProcessStep)
    while (userSelectedProcessStep != lastCurrentProcessStep && userSelectedProcessStep != plateTypeFirstProcessStep) {
      let y = mapOfProcessSteps.get(userSelectedProcessStep)
      remainingProcessStepList.push(y[0])
      userSelectedProcessStep = y[0]
    }
    if (remainingProcessStepList.includes(selectedProcessStep)) {
      remainingProcessStepList = remainingProcessStepList.filter(function (item) {
        return item !== selectedProcessStep
      })
    }
    if (remainingProcessStepList.includes(lastCurrentProcessStep)) {
      remainingProcessStepList = remainingProcessStepList.filter(function (item) {
        return item !== lastCurrentProcessStep
      })
    }
    return remainingProcessStepList
  }


  updatePlateProcessStepsBasedOnProcessStepsStart(resettedPlateProcessSteps, statusProcessStep, selectedProcessStep) {
    //Function which returns the updated ProcessSteps based on the selected status' process step (start status)

    if (statusProcessStep.step == ProcessStep.AMPLIFY_WGA || statusProcessStep.step == ProcessStep.AMPLIFY_PGX) {
      resettedPlateProcessSteps = resettedPlateProcessSteps.slice(0, 1)
      this.processCurrent = {
        action: [],
        chemicals: [],
        endPUID: "",
        endTimeStamp: null,
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: new Date(),
        step: ProcessStep.AMPLIFY_WGA
      }
      resettedPlateProcessSteps.push(this.processCurrent)

      this.processCurrent = {
        action: [],
        chemicals: [],
        endPUID: "",
        endTimeStamp: null,
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: new Date(),
        step: ProcessStep.AMPLIFY_PGX
      }
      resettedPlateProcessSteps.push(this.processCurrent)
    }
    else {
      this.processCurrent = {
        action: [],
        chemicals: [],
        endPUID: "",
        endTimeStamp: null,
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: new Date(),
        step: selectedProcessStep
      }
      resettedPlateProcessSteps.push(this.processCurrent)
    }

    return resettedPlateProcessSteps
  }


  updatePlateProcessStepsBasedOnProcessStepsComplete(resettedPlateProcessSteps, newProcessStepActions) {
    //Function which returns the updated ProcessSteps based on the selected status' process step (complete status)

    if (this.updatedStatus == PlateStatus.PREPCR_COMPLETED) {
      let tempActions2 = []
      newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(ProcessStep.AMPLIFY_WGA)
      if (newProcessStepActions != undefined) {
        newProcessStepActions.forEach(function (item, index) {
          let temp = {
            "action": item,
            "actionStartTime": new Date(),
            "actionPUID": this.puid,
            "actionRunTime": 0
          }
          tempActions2.push(temp)
        }, this);
      }
      this.processCurrent = {
        action: newProcessStepActions != undefined ? tempActions2 : [],
        chemicals: [],
        endPUID: this.puid,
        endTimeStamp: new Date(),
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: null,
        step: ProcessStep.AMPLIFY_WGA
      }
      resettedPlateProcessSteps.push(this.processCurrent)

      let tempActions3 = []
      newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(ProcessStep.AMPLIFY_PGX)
      if (newProcessStepActions != undefined) {
        newProcessStepActions.forEach(function (item, index) {
          let temp = {
            "action": item,
            "actionStartTime": new Date(),
            "actionPUID": this.puid,
            "actionRunTime": 0
          }
          tempActions3.push(temp)
        }, this);
      }
      this.processCurrent = {
        action: newProcessStepActions != undefined ? tempActions3 : [],
        chemicals: [],
        endPUID: this.puid,
        endTimeStamp: new Date(),
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: null,
        step: ProcessStep.AMPLIFY_PGX
      }
      resettedPlateProcessSteps.push(this.processCurrent)
    }
    else if (this.updatedStatus == PlateStatus.WGA_COMPLETED) {
      let tempActions2 = []
      newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(ProcessStep.AMPLIFY_WGA)
      if (newProcessStepActions != undefined) {
        newProcessStepActions.forEach(function (item, index) {
          let temp = {
            "action": item,
            "actionStartTime": new Date(),
            "actionPUID": this.puid,
            "actionRunTime": 0
          }
          tempActions2.push(temp)
        }, this);
      }
      this.processCurrent = {
        action: newProcessStepActions != undefined ? tempActions2 : [],
        chemicals: [],
        endPUID: this.puid,
        endTimeStamp: new Date(),
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: null,
        step: ProcessStep.AMPLIFY_WGA
      }
      resettedPlateProcessSteps.push(this.processCurrent)
      let tempActions3 = []
      newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(ProcessStep.AMPLIFY_PGX)
      if (newProcessStepActions != undefined) {
        newProcessStepActions.forEach(function (item, index) {
          let temp = {
            "action": item,
            "actionStartTime": new Date(),
            "actionPUID": this.puid,
            "actionRunTime": 0
          }
          tempActions3.push(temp)
        }, this);
      }
      this.processCurrent = {
        action: [],
        chemicals: [],
        endPUID: null,
        endTimeStamp: null,
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: new Date(),
        step: ProcessStep.AMPLIFY_PGX
      }
      resettedPlateProcessSteps.push(this.processCurrent)
    }
    else if (this.updatedStatus == PlateStatus.PGX_COMPLETED) {
      let tempActions2 = []
      newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(ProcessStep.AMPLIFY_WGA)
      if (newProcessStepActions != undefined) {
        newProcessStepActions.forEach(function (item, index) {
          let temp = {
            "action": item,
            "actionStartTime": new Date(),
            "actionPUID": this.puid,
            "actionRunTime": 0
          }
          tempActions2.push(temp)
        }, this);
      }
      this.processCurrent = {
        action: [],
        chemicals: [],
        endPUID: null,
        endTimeStamp: null,
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: new Date,
        step: ProcessStep.AMPLIFY_WGA
      }
      resettedPlateProcessSteps.push(this.processCurrent)

      let tempActions3 = []
      newProcessStepActions = this.mapOfPlateProcessStepAndAction.get(ProcessStep.AMPLIFY_PGX)
      if (newProcessStepActions != undefined) {
        newProcessStepActions.forEach(function (item, index) {
          let temp = {
            "action": item,
            "actionStartTime": new Date(),
            "actionPUID": this.puid,
            "actionRunTime": 0
          }
          tempActions3.push(temp)
        }, this);
      }
      this.processCurrent = {
        action: newProcessStepActions != undefined ? tempActions3 : [],
        chemicals: [],
        endPUID: this.puid,
        endTimeStamp: new Date(),
        liquidHandler: "",
        startPUID: this.puid,
        startTimeStamp: new Date(),
        step: ProcessStep.AMPLIFY_PGX
      }
      resettedPlateProcessSteps.push(this.processCurrent)
    }

    return resettedPlateProcessSteps
  }

  calculateSelectedStatusIndexBatch(array) {
    //Function to calculated selected status' index

    let selectedStatusIndex = -1
    array.forEach(function (value, index) {
      if (value.includes(this.updatedStatus)) {
        selectedStatusIndex = array.indexOf(value)
      }
    }, this)

    return selectedStatusIndex
  }

  updatePlateArchiveData(archivedPlateProcessSteps) {
    //Function to update the plate's archive data

    this.selectedPlate.archiveData = this.selectedPlate.archiveData == null ? [] : this.selectedPlate.archiveData
    if (this.selectedPlate.archiveData && archivedPlateProcessSteps.length > 0) {
      this.selectedPlate.archiveData.push(archivedPlateProcessSteps)
    }
    else if (archivedPlateProcessSteps && archivedPlateProcessSteps.length > 0) {
      this.selectedPlate.archiveData.push(archivedPlateProcessSteps)
    }
  }

  updateBatchArchiveDataAndComments(archivedPlateProcessSteps) {
    //Function to update batch's archive data and comments

    this.selectedBatch.archiveData = this.selectedBatch.archiveData == null ? [] : this.selectedBatch.archiveData
    if (this.selectedBatch.archiveData && archivedPlateProcessSteps.length > 0) {
      this.selectedBatch.archiveData.push(archivedPlateProcessSteps)
    }
    else if (archivedPlateProcessSteps && archivedPlateProcessSteps.length > 0) {
      this.selectedBatch.archiveData.push(archivedPlateProcessSteps)
    }

    if (this.selectedBatch.comments) {
      this.selectedBatch.comments.push(this.batchComment)
    }
    else {
      this.selectedBatch.comments = [this.batchComment]
    }
  }

  updateStatus() {
    let selectedPlateProcessSteps = []
    let resettedPlateProcessSteps = []
    let archivedPlateProcessSteps = []
    let array = []
    let selectedProcessStep
    if (!this.selectedPlate) {
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'Plate not found', summary: 'The selected plate was not found'
      })
      return
    }
    else if (!localStorage.getItem('PUID')) {
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'User not logged in', summary: 'Please login and try again.'
      })
      return
    }
    else if (this.tempStatus == '') {
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'Status not selected', summary: 'Please select a status.'
      })
      return
    }
    else if (!this.commentStatusSet) {
      this._messagesService.addErrorMessage({
        severity: 'error', detail: 'Please set a comment to document the change.', summary: 'Comment not entered'
      })
      return
    }

    if (this.isPlate && this.applicationProcess == 'ARRAY') {
      selectedPlateProcessSteps =  this.selectedPlate.processSteps;
      this.updatePlateStatus(selectedPlateProcessSteps, resettedPlateProcessSteps, archivedPlateProcessSteps, array, selectedProcessStep)
    }
    else if (this.isBeadchip && this.applicationProcess == 'ARRAY') {
      selectedPlateProcessSteps =  this.selectedPlate.processSteps;
      this.updateBeadChipStatus(selectedPlateProcessSteps, resettedPlateProcessSteps, archivedPlateProcessSteps, array, selectedProcessStep)
    }
    else if (this.isBatch && this.applicationProcess == 'NGS') {
      selectedPlateProcessSteps =  this.selectedPlate.processSteps;
      this.updateBatchStatus(selectedPlateProcessSteps, resettedPlateProcessSteps, archivedPlateProcessSteps, array, selectedProcessStep)
    }
  }

  search(searchID: string) {
    this.statusUpdated = false
    this.isBatch = false
    this.isPlate = false
    this.isBeadchip = false
    this.isSample = false
    this.searchedText = searchID
    this.selectedPlate = new Plate();
    if (!searchID || searchID.trim() == "") {
      this._messagesService.addWarningMessage({
        severity: "warn",
        summary: "Search ID Empty",
        detail: "Please enter Search ID to search",
      });
      return;
    }
    if (this.typeOfView == 'PlateView') {
      if (this.regexMatcher(this.beadchipIDRegex, searchID) && this.applicationProcess == 'ARRAY') {
        this.plateStatus = beadChipStatusDict
        this.isBeadchip = true;
        this.isBatch = false
        this.searchingBeadchip(searchID, 'BEADCHIP');
        this.isPlate = false;
        this.isSample = false;
      } else if (this.regexMatcher(this.batchIDRegex, searchID) && this.applicationProcess == 'NGS') {
        this.plateStatus = ngsPlateStatus
        this.isBeadchip = false;
        this.isPlate = false;
        this.isBatch = true;
        this.isSample = false;
        this.searchingBatchID(searchID);
      } else {
        this.plateStatus = ArrayPlateStatus
        this.searchingPlate(searchID)
      }
    }
    else if (this.typeOfView == 'SampleView') {
      this.plateStatus = ArrayPlateStatus
      this.position = "";
      this.sampleId = "";
      this.searchingSample(searchID);
      this.isPlate = false;
      this.isBeadchip = false;
    }
  }


  searchingPlate(searchID: string) {
    this.adminSearchService.fetchPlateByPlateIDandLab(this.selectedLabId, searchID).subscribe({
      next: (result) => {
        this.isBatch = false
        this.isPlate = true
        this.isBeadchip = false
        this.isSample = false
        this.selectedPlateID = result
        this.fetchPlate(this.selectedPlateID);
      },
      error: (error) => {
          this.searchedBeadchipID = ''
          this.beadchipStatus = ''
          this.isPlate = false
          this._messagesService.addErrorMessage({
          severity: 'error', detail: "Plate not found", summary: "Plate not found"
          })
        }
      }
    )
  }
  plateHistoryModule(plate_id: string) {
    this.blocked = true
    this.sourcePlates = [];
    this.adminSearchService.getPlateHistory(this.selectedLabId, plate_id).subscribe({
      next: (result) => {
        this.blocked = false
        this.isPlate = true;
        this.selectedPlate = result.data
        this.selectedPlate.sourcePlates.forEach(sourcePlate => {
          this.sourcePlates.push(sourcePlate.plateID);
        });
        this.tempStatus = this.selectedPlate.status
        this.processDataList = []
        this.getSampleTypefromMDM();
        this.getSelectedPlateProcessSteps();

        if(this.sourcePlates.length !== 0){
          this.redoList = this.mergeRedoList
        }
        else{
          this.populateRedoTypeDropDown(this.selectedPlate)
        }
        this.selectedPlate.processSteps.forEach((process, _index) => {

          if(process === null || process.status === null){
            return
          }

          if (process['action'].length == 0 || this.noActionRequiredStatus.includes(process['status'])) {
            this.processDataList.push(this.createProcessDataListWithNoActions(process))
          }
          else {
            this.processDataList.push(this.createProcessDataListWithAction(process))
          }
        });
      },
       error: (_error) => {
          this.blocked = false;
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed to fetch plate history info',
            detail: "Plate History fetch failed"
          })
        }
      }
    )
  }
  fetchPlate(plateID) {
    this.sampleIds = [];
    this.blocked = true
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe({
      next: (result) => {
        this.blocked = false;
        this.plateData = result;
        if(this.plateData.samples.length!=0){
          this.plateData.samples.forEach(sample=>{
            this.sampleIds.push(sample._id)
          })
        }
        this.selectedPlateLastStep = this.plateData.processSteps[this.plateData.processSteps.length - 1]?.step
        this.plateHistoryModule(this.selectedPlateID)
        this.selectedSampleType = "";
        this.selectedStatus = "";
      },
      error: (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: "Plate fetch failed"
        })
      }
    });
  }

  populateRedoTypeDropDown(plate: Plate) {
    this.blocked = true
    this.platePreparationService.getProcessFlow(plate.processFlowName, this.selectedLabId).subscribe({
      next : (processFlowResult) => {
        this.redoList = [];
        this.blocked = false
        let processFlow: ProcessFlow
        if (processFlowResult.data) {
          processFlow = processFlowResult.data

          if (processFlow.okTOpureHair) {
            this.redoList = this.prepareRedoListBasedOnStatus(this.hairRedoList);
          } else if (processFlow.okTOpureEartag) {
            this.redoList = this.prepareRedoListBasedOnStatus(this.eartagRedoList);
          } else if (processFlow.ExEartagTLR) {
            this.redoList = this.prepareRedoListBasedOnStatus(this.tlrRedoList);
          } else {
            this.redoList = [];
          }

          if (plate.sampleType == "DNA" && plate.processSteps.length > 1) {
            if(plate.workFlow=="ICBF"){
              this.redoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": plate.processSteps[1].step, status: PlateStatus.RECEPTION_COMPLETED}});
            }else{
              this.redoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": ProcessStep.AMPLIFY_WGA, status: PlateStatus.RECEIVED}});
            }
          }
        }
      },
      error: (_error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'No process flow found',
          detail: 'Either no configured process flow in MDM or no sample type in plate.'
        });
      }
    })
  }

  prepareRedoListBasedOnStatus(redoList: any[]): any[] {
    let redoSet = new Set();
    const stepMapping = {
      'LYSIS': 'Lysis Redo',
      'EXTRACTION': 'Extraction Redo',
      'ALIQUOTATION': 'Aliquotation Redo'
    }

    this.plateData.processSteps.forEach(processStep => {
      const matchedRedo = redoList.find(redo => redo.label === stepMapping[processStep.step] && processStep.endTimeStamp !== null)

      if (matchedRedo) {
        redoSet.add(matchedRedo);
      }
    })

    return Array.from(redoSet);
  }

  addPlateForRedo() {
    let plateUpdateInfo = new PlateUpdateInfo()
    plateUpdateInfo.plateID = this.selectedPlate.plateID
    plateUpdateInfo.lastUpdatedPlateID = this.selectedPlate.lastUpdatedPlateID
    plateUpdateInfo.redoLabel = this.selectedRedoReason.redoLabel
    plateUpdateInfo.redo = this.selectedRedoReason.redo
    plateUpdateInfo.status = this.selectedRedoReason.status
    plateUpdateInfo.sampleType = this.selectedRedoReason.sampleType
    plateUpdateInfo.stepName = this.selectedRedoReason.stepName


    this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
    this.multiUpdatePlateList.unshift(this.selectedPlate.plateID)
    this.multiUpdatePlateListSave.unshift(this.selectedPlate.lastUpdatedPlateID);
  }

  redoPlate() {
    if(this.sourcePlates.length !== 0){
      this.showRedoPopUpForMergePlate(this.selectedPlate)
      return;
    }
    this.addPlateForRedo();
    let multiUpdateDto = this.getRedoPlateMultiUpdateDto();
    this.blocked = true
    let sampleRedoDetails = new SampleRedoDTO();
    sampleRedoDetails.sampleIdList = this.sampleIds.map(sample => {
      let sampleWithAnalysisType = new SampleWithAnalysisType()
      sampleWithAnalysisType.sampleID = sample
      sampleWithAnalysisType.type = AnalysisType.INTERNAL_RERUN
      return sampleWithAnalysisType
    });
    sampleRedoDetails.analysisType = true;
    sampleRedoDetails.reRunCount = false;
    this.platePreparationService.updateQCCheckForMultiplePlates(multiUpdateDto, this.selectedLabId).subscribe({
      next: (result) => {
        this.announcementService.updateRedoSample(this.selectedLabId, sampleRedoDetails).subscribe(
          _result=>{
            this._messagesService.addSuccessMessage({
              severity:'success',summary:"Success!", detail: result
            })
          }
        )
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: "Plate Updated Successfully" })
        this.lastUpdatedStatus = multiUpdateDto.status;
        if (PlateStatus.PLATE_REDO == multiUpdateDto.status) {
          this.selectedPlateStepsMap.clear();
        }
        this.plateHistoryModule(this.selectedPlate.plateID)
        this.clearRedoTypeData();
      },
      error: (error) => {
          this.blocked = false
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
        }
      }
    )
  }

  getRedoPlateMultiUpdateDto() {
    let multiPlateUpdate: MultiPlateUpdate = new MultiPlateUpdate();
    multiPlateUpdate.plateids = this.multiUpdatePlateListSave
    multiPlateUpdate.plateUpdateInfoList = this.multiUpdatePlateInfoList
    multiPlateUpdate.labid = this.selectedLabId;
    multiPlateUpdate.puid = this.puid;
    multiPlateUpdate.liquidHandler = this.multiLiquidHandler;
    multiPlateUpdate.actionRunTime = 0;
    multiPlateUpdate.processFlow = this.selectedPlate.processFlowName;
    if(this.selectedPlate.type === "BEADCHIP"){
      multiPlateUpdate.beadChipRedo = true;
    }
    return multiPlateUpdate;
  }

  clearRedoTypeData() {
    this.multiUpdatePlateList = [];
    this.multiUpdatePlateListSave = [];
    this.multiUpdatePlateInfoList = [];
    this.selectedRedoReason ="";
  }

  updatePlateProcessflowname(){
    let data = {
      "sampleType" :  this.selectedSampleType,
      "processFlowName": this.sampleTypeAndProcessFlowNameMap.get(this.selectedSampleType),
      "plateid":this.selectedPlate.plateID,
      "labid":this.selectedLabId
    }

    if (!this.sampleTypeAllowedStatuses.includes(this.selectedPlate.status)) {
      this._messagesService.addWarningMessage({
        severity: "error",
        summary: "Sample Type not updated",
        detail: "Plate has exceeded QC Scan step"
      });
      return;
    } else {
      this.blocked = true;
      this.platePreparationService.updatePlateProcessflowname(data).subscribe({
        next: (_result) => {
          this.blocked = false
          if (this.sampleIds.length != 0) {
            this.updateSampleTypeOfSamples();
          }
          this.plateHistoryModule(this.selectedPlate.plateID);
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Plate SampleType Updated Successfully' })
          this.selectedSampleType = "";
        },
        error: (error) => {
            this.blocked = false
            this.selectedSampleType = "";
            this.showError(error)
          }
        }
      )
    }
  }

  updateSampleTypeOfSamples() {
    this.blocked = true;
    this.announcementService.updateAssignedSampleTypeOfSamples(this.selectedLabId, this.sampleIds, this.selectedSampleType).subscribe({
      next: (_result) => {
        this.blocked = false
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Plate SampleType Updated Successfully' })
      },
      error: (error) => {
          this.blocked = false
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
        }
      }
    )
  }

  getSelectedPlateProcessSteps() {
    this.statusList = [];
    let processStepStatusMap = new Map();
    let conditionMet = false;
    if(this.selectedPlate.type === 'PLATE'){
        this.statusList.push({ label: "NOT_PROCESSED", value: "NOT_PROCESSED" });
        this.statusList.push({ label: "RETURNED", value: "RETURNED"});
    }
    this.selectedPlate.processSteps.forEach(process=>{
      if(process.step == "QC_SCAN" && process.status != "QCSCAN_STARTED" && process.endTimeStamp !=null){
        processStepStatusMap = new Map();
        processStepStatusMap.set(process.status, process.step)
      }else if(process.step != "QC_SCAN"){
        processStepStatusMap.set(process.status, process.step)
      }
    })
    if (this.plateData.processSteps && this.plateData.processSteps.length > 0) {
      let lastProcessStep = this.plateData.processSteps[this.plateData.processSteps.length - 1];
      processStepStatusMap.forEach((step, status) => {
        if (!conditionMet && step === lastProcessStep.step && status === this.selectedPlate.status) {
          conditionMet = true
          return;
        } else if (!conditionMet) {
          this.statusList.push({ label: status, value: status });
        }
      });
    }
  }

  openPlateIDSelectionPopUp(){
    this.plateIDSelectionDialog = true
    for(let idType of this.plateIDSelectionList){
      if(!this.selectedPlate[idType.value.key])
        continue;

      const modifiedIDType = Object.assign({},idType)
      modifiedIDType.label = `${modifiedIDType.label} (${this.selectedPlate[modifiedIDType.value.key]})`
      this.plateIDList.push(modifiedIDType)
    }
    this.selectedPlateIDType = { type:PlateIdTypes.LAST_UPDATED_PLATEID, key:"lastUpdatedPlateID" }
  }

  updatePlateSelectedStatus(){
    this.blocked = true;
    const idType = this.selectedPlateIDType.key;
    const updatedPlateID = this.selectedPlate[idType];
    const qcNanoDropConfigured = this.selectedProcessFlows.find(processFlow => processFlow.processFlowName === this.selectedPlate.processFlowName)?.qcNanodrop;
    this.platePreparationService.updatePlateSelectedStatus(
      this.selectedLabId,
      this.selectedPlate.plateID,
      this.selectedStatus,updatedPlateID,
      this.puid,
      qcNanoDropConfigured
      ).subscribe({
        next: (_result) => {
          this.blocked = false;
          this.plateHistoryModule(this.selectedPlate.plateID)
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: 'Plate Status Updated Successfully' })
          this.resetValues();
        },
        error: (error) => {
          this.blocked = false;
          this.showError(error);
          this.resetValues();
        }
      });
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  disableStatusDropDown(){
    return this.statusList.length === 0 || this.plateData.status === 'PLATE_REDO';
  }

  resetData() {
    this.isPlate = false;
    this.isSample = false;
    this.plateData = null;
    this.selectedPlate = null;
    this.sampleData = null;
    if (this.idInput) {
      this.idInput.nativeElement.value = '';
    }
  }

  onFileSelect(filesData){
    if(filesData.target.files.length === 0){
      this.isFileSelected = false;
      return;
    }
    const file = filesData.target.files[0];
    this.uploadedExternalRedoFile = file
    this.isFileSelected = true;
  }

  uploadExternalRedoFile(){
    const externalRedoFormData = new FormData();
    externalRedoFormData.append('file',this.uploadedExternalRedoFile);
    externalRedoFormData.append("labID",this.selectedLabId);
    externalRedoFormData.append("puid",this.puid)

    this.blocked = true
    this.adminSearchService.uploadExternalRedoFile(externalRedoFormData).subscribe({
      next: (result) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          summary:"External analysis file uploaded",
          detail:result,
          severity:'success'
        })
        this.externalRedoFileRef.nativeElement.value = ""
        this.plateHistoryModule(this.selectedPlate.plateID);
      },
      error: (error) => {
          this.blocked = false;
          this.externalRedoFileRef.nativeElement.value = ""
          this.showError(error)
        }
      }
    )
  }

  showRedoPopUpForMergePlate(fetchedPlate: Plate){
    this.popUpWithQCCheckForMergePlate = true;
    this.mergePlateRedoSelection = [];
    fetchedPlate.sourcePlates.forEach( (sourcePlate,index) => {
      this.mergePlateRedoSelection.push({});
      this.mergePlateRedoList.push([]);
      this.getMergePlateRedoList(sourcePlate.processFlowName, index);
    })
  }

  getMergePlateRedoList(processFlowName: string, index: number){
    let processFlow: ProcessFlow;
    let redoList = [];
    this.blocked=true;
    this.platePreparationService.getProcessFlow(processFlowName, this.selectedLabId).subscribe({
      next: (process_flow_result) => {
        this.blocked=false;
        if (process_flow_result.data) {
          processFlow = process_flow_result.data

          if(processFlow.okTOpureHair){
            redoList = this.clone(this.hairRedoList);
          }else if(processFlow.okTOpureEartag){
            redoList = this.clone(this.eartagRedoList);
          }else if(processFlow.ExEartagTLR){
            redoList = this.clone(this.tlrRedoList);
          }else{
            redoList = [];
          }

          if(this.selectedPlate.sampleType=="DNA" && this.selectedPlate.processSteps.length > 1){
            redoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": this.selectedPlate.processSteps[1].step, status: PlateStatus.RECEIVED}});
          }

          this.mergePlateRedoList[index]=redoList;
        }
        else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'No process flow found',
            detail: 'Either no configured process flow in MDM or no sample type in plate.'
          });
        }
      },
      error: (error) => {
        this.blocked = false;
        this.popUpWithQCCheckForMergePlate = false;
        this.showError(error);
      }
    })
  }

  sendSourcePlatesForRedo() {
    this.mergePlateRedoSelection.forEach( (redoSelection,index) => {
      let sourcePlateUpdateInfo = new PlateUpdateInfo();
      sourcePlateUpdateInfo.plateID = this.selectedPlate.sourcePlates[index].plateID;
      sourcePlateUpdateInfo.redoLabel = redoSelection.redoLabel;
      sourcePlateUpdateInfo.redo = redoSelection.redo;
      sourcePlateUpdateInfo.status = redoSelection.status;
      sourcePlateUpdateInfo.sampleType = redoSelection.sampleType;
      sourcePlateUpdateInfo.stepName = redoSelection.stepName;
      sourcePlateUpdateInfo.lastUpdatedPlateID = this.selectedPlate.sourcePlates[index].lastUpdatedPlateID;


      this.multiUpdatePlateInfoList.push(sourcePlateUpdateInfo);
      this.multiUpdateMergeRedoPlates.set(this.selectedPlate.lastUpdatedPlateID, this.multiUpdatePlateInfoList);
      this.multiUpdatePlateListSave.push(sourcePlateUpdateInfo.lastUpdatedPlateID)

    })

    let sampleRedoDetails = new SampleRedoDTO();
    sampleRedoDetails.sampleIdList = this.sampleIds.map(sample => {
      let sampleWithAnalysisType = new SampleWithAnalysisType()
      sampleWithAnalysisType.sampleID = sample
      sampleWithAnalysisType.type = AnalysisType.INTERNAL_RERUN
      return sampleWithAnalysisType
    });
    sampleRedoDetails.analysisType = true;
    sampleRedoDetails.reRunCount = false;

    let multiUpdateDto = this.getRedoPlateMultiUpdateDto()
    this.platePreparationService.updateQCCheckForMultiplePlates(multiUpdateDto, this.selectedLabId).subscribe({
      next: (result) => {
        this.announcementService.updateRedoSample(this.selectedLabId, sampleRedoDetails).subscribe(
          _result=>{
            this._messagesService.addSuccessMessage({
              severity:'success',summary:"Success!", detail: result
            })
          }
        )
        this.blocked = false;
        if(this.selectedPlate.type === "BEADCHIP"){
          this.redoArrayInResultEvaluation();
        }
        if(this.multiUpdateMergeRedoPlates.size !=0 ){
          this.updateMultiMergeQCCheckPlates()
        }
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: "Plate Updated Successfully" })
        this.lastUpdatedStatus = multiUpdateDto.status;
        if (PlateStatus.PLATE_REDO == multiUpdateDto.status) {
          this.selectedPlateStepsMap.clear();
        }
        this.plateHistoryModule(this.selectedPlate.plateID)
        this.clearRedoTypeData();
      },
      error: (error) => {
        this.blocked = false
        this.showError(error)
        this.resetValues()
        }
      }
    )
  }

  prepareMergePlateQCScanDTO(){
    let dto: MultiMergePlateQCUpdate = new MultiMergePlateQCUpdate();
    dto.labid = this.selectedLabId;
    dto.action = Action.QC_CHECK;
    dto.step = this.selectedPlateLastStep;
    dto.labid = this.selectedLabId;
    dto.puid = this.puid;
    this.multiUpdateMergeRedoPlates.forEach( (value, key) => {
      dto.plateids.push(key);
      dto.plateUpdateInfoList[key] = value
    })
    return dto
  }

  updateMultiMergeQCCheckPlates(){
    let multiUpdateDTO = this.prepareMergePlateQCScanDTO();
    this.blocked = true
    this.platePreparationService.updateQCCheckForMultipleMergePlates(multiUpdateDTO, this.selectedLabId).subscribe({
      next: (result) => {
        this.blocked = false;
        this.multiUpdateMergeRedoPlates.clear();
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.resetValues()
      },
      error: (error) => {
          this.blocked = false
          this.showError(error)
          this.resetValues()
        }
      }
    )
  }

  redoArrayInResultEvaluation(){
    const plateUpdateDTO = this.createDataForPlateUpdate();
    this.blocked = true;
    this.resultEvaluationService.updateArrayStatus(plateUpdateDTO).subscribe({
      next: (result) =>{
        this.blocked = false;

        this._messagesService.addSuccessMessage({
          severity:"success", summary:"Array Updated!",
          detail:`Array ${this.selectedPlate.plateID} successfully sent for redo!`
        })
      },
      error: (error) => {
          this.blocked = false
          this.showError(error)
          this.resetValues()
        }
      }
    )
  }

  createDataForPlateUpdate(){
    const plateUpdateDTO = new PlateUpdateDTO();
    plateUpdateDTO.labID = this.selectedLabId;
    plateUpdateDTO.plateID = this.selectedPlate.plateID;
    plateUpdateDTO.status = "PLATE_REDO";
    return plateUpdateDTO;
  }

}
